import { inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};

  background: var(--bgColor);
  color: var(--fgColor);
  margin: var(--sectionSpacing) 0;
`;
const Inner = styled.div `
  ${baseGrid};
  row-gap: 48px;

  @media ${from(Device.TabletLarge)} {
    grid-template-rows: auto 1fr;
    row-gap: 72px;
  }
`;
const Title = styled.h2 `
  ${h3};
  grid-column: 1 / span 12;
  grid-row: 2;
  margin: 0;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
    grid-row: 1;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 2 / span 5;
    grid-row: 1;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 4;
    grid-row: 1;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Image = styled(SimpleImage) `
  grid-column: 1 / span 12;
  grid-row: 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 7 / span 6;
    grid-row: 1 / span 2;
    justify-self: flex-end;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 7 / span 5;
    grid-row: 1 / span 2;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 7 / span 5;
    grid-row: 1 / span 2;
  }

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const FormWrapper = styled.div `
  grid-column: 1 / span 12;
  grid-row: 3;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
    grid-row: 2;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 2 / span 5;
    grid-row: 2;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 4;
    grid-row: 2;
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const ContactFormSectionStyles = {
    Container,
    FormWrapper,
    Image,
    Inner,
    Title,
};
export default ContactFormSectionStyles;
